import { useState, useRef, useEffect } from "react";
import Layout from "../components/Layout/Layout";
import axios from "axios";
import { SparklesIcon } from "@heroicons/react/24/solid";
import { ArrowUpTrayIcon, BookmarkSquareIcon, PaperAirplaneIcon, PlayCircleIcon, PlusCircleIcon, XCircleIcon, MicrophoneIcon } from "@heroicons/react/24/outline";
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import { Loader2, PauseCircleIcon } from "lucide-react";
import clipsData from "../Json/clips.json";
import { ChevronLeftIcon, ChevronRightIcon, VideoCameraIcon, CursorArrowRippleIcon } from '@heroicons/react/24/outline';
import MediaThemeTailwindAudio from 'player.style/tailwind-audio/react';
import { convertDateTimeToFormat } from "../components/utils/utils";
const PODCAST_BASE_URL = process.env.REACT_APP_PODCAST_URL;
const podcast_bearer_token = "5sL2QSXqE0Yal8OwPwwMliuEfAz2SzmeYilJeitaXmiVWFaxdvYSSkdWwpPYEfTa";


export default function Podcast() {
  // === Tab states for listing / create
  const [active, setActive] = useState(2); // default to Create Podcast (2) to preserve current behavior
  const menu = [
    { id: 1, label: "Podcast Listing" },
    { id: 2, label: "Create Podcast" }
  ];

  // === Listing API states
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [listing, setListing] = useState([]);
  const [listingLoading, setListingLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(0);

  const Category_map = {
    News: ["Education", "Job", "Career", "Poora Sach","Pulwama Ke Shahid","National"],
    HealthAndFitness: ["Healthcare", "Excercise fitness"],
    Astrology: ["General", "Rashifal", "Celebrity Rashifal ","Chinese Rashifal","Career Rashifal","Love Rashifal","Financial Rashifal","Numerology"],
    Business: ["Budget Analysis", "biz", "savings","Investment tax","banking loan","insurance","FAQ","QNA","top 15","Budget","Budget Expectation","Budget impact","Expert Column"],
    Cricket: ["Previews","Match Report","Interview","World Cup","IPL","Headlines","Apni Baat","Experts","Bouncer"],
    Entertainment: ["Hollywood","Bollywood Vishesh","Print Reviews","Web Series Review","Behind the scene","TV","Bollywood","Controversy","Box office","Biography","Interview","Reviews","Actually","Article","Memories","Upcoming Movies"],
    Lifestyle: ["Lifestyle News","Relationships","Festivals","Food News","Affiliates","Health","Travel Tourism","Fashion Beauty","Miscellaneous"],
    Spiritual: ["Religion","Puja Path","Sant Saadhak","Mukhye Dharmik Sthal","Numerology Horoscope","Career Astrology","Vastu Shastra","Ekadashi","Lal Kitab","Grah Nakshatra"],
    Technology: ["Review","Tech  Guide","Apps","Social Media","Tech News","Latest Launch","Affiliates"],
    World: ["America","Pakistan","China","Middle East","United Kingdom","Indonesia","Japan","Canada","Russia","Other"]
  }

  const fetchListing = async () => {
    setListingLoading(true);
    try {
      const res = await axios.get(`${PODCAST_BASE_URL}listing/${page}/${limit}`,
        {
          headers: {
            Authorization: `Bearer ${podcast_bearer_token}`
          }
        }
      );
      setListing(res?.data?.data || []);
      setTotalPages(res?.data?.pagination?.totalPages || 0);
    } catch (err) {
      console.error("Error fetching listing:", err);
      setListing([]);
    } finally {
      setListingLoading(false);
    }
  };

  const filteredListing = listing.filter((pod) => {
    const categoryMatch =
      !selectedCategory || pod.Category === selectedCategory;

    const subCategoryMatch =
      !selectedSubCategory || pod.SubCategory === selectedSubCategory;

    return categoryMatch && subCategoryMatch;
  });

  useEffect(() => {
    if (active === 1) fetchListing();
  }, [active, page]);

  // ===========================
  // Original states & refs
  // ===========================
  const [audioFiles, setAudioFiles] = useState([]);
  const [mergedAudioUrl, setMergedAudioUrl] = useState(null);
  const [mergedAudioName, setMergedAudioName] = useState("");
  const [introOutroClips, setIntroOutroClips] = useState(clipsData);
  const [playingClipId, setPlayingClipId] = useState(null);
  const [open, setOpen] = useState(false);
  const [isCombining, setIsCombining] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [transcriptFile, setTranscriptFile] = useState(null);
  const [transcriptText, setTranscriptText] = useState("");
  const [transcriptMode, setTranscriptMode] = useState("file");
  const [metadata, setMetadata] = useState(null);
  const [metadataError, setMetadataError] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [keywords, setKeywords] = useState("");
  const [engUrl, setEngUrl] = useState("");
  const [genre, setGenre] = useState("");
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [referencedUrl, setReferencedUrl] = useState("");
  const [llmFileName, setLlmFileName] = useState("");
  const [introFileName, setIntroFileName] = useState("");
  const [outroFileName, setOutroFileName] = useState("");
  const [introFileUrl, setIntroFileUrl] = useState(""); // New state for intro file URL
  const [outroFileUrl, setOutroFileUrl] = useState(""); // New state for outro file URL
  const audioRefs = useRef({});

  const handleAudioFiles = (e) => {
    const files = Array.from(e.target.files); // Get LLM file from input
    const llmFile = files[0]; // Take the first file as the LLM file
    if (llmFile) {
      // Identify existing intro and outro files
      const introFile = audioFiles.find(file => file.name.toLowerCase().includes('intro'));
      const outroFile = audioFiles.find(file => file.name.toLowerCase().includes('outro'));
      // Construct new array in order: [intro, llm, outro]
      const newAudioFiles = [
        ...(introFile ? [introFile] : []), // Keep existing intro if present
        llmFile, // Add new LLM file
        ...(outroFile ? [outroFile] : []) // Keep existing outro if present
      ];
      setAudioFiles(newAudioFiles);
      setLlmFileName(llmFile.name); // Store the LLM file name
      console.log("Selected LLM audio file:", llmFile);
      console.log("Updated audio files:", newAudioFiles);
      console.log("Current audio files:", audioFiles);
    }
  };

  // Handle adding intro and outro clips
  const handleAddIntroOutro = async (introUrl, outroUrl) => {
    try {
      // Fetch the intro and outro audio files
      const introResponse = await fetch(introUrl);
      const outroResponse = await fetch(outroUrl);

      if (!introResponse.ok || !outroResponse.ok) {
        throw new Error("Failed to fetch intro or outro audio files");
      }

      const introBlob = await introResponse.blob();
      const outroBlob = await outroResponse.blob();

      // Create File objects with actual audio data
      const introFile = new File([introBlob], introUrl.split("/").pop(), { type: "audio/mpeg" });
      const outroFile = new File([outroBlob], outroUrl.split("/").pop(), { type: "audio/mpeg" });

      // Identify existing LLM file (not intro or outro)
      const llmFile = audioFiles.find(
        (file) => !file.name.toLowerCase().includes("intro") && !file.name.toLowerCase().includes("outro")
      );

      // Construct new array in order: [intro, llm, outro]
      const newAudioFiles = [
        ...(introFile ? [introFile] : []), // Add new intro if provided
        ...(llmFile ? [llmFile] : []), // Keep existing LLM file if present
        ...(outroFile ? [outroFile] : []), // Add new outro if provided
      ];

      setAudioFiles(newAudioFiles);
      setIntroFileName(introFile.name); // Store intro file name
      setOutroFileName(outroFile.name); // Store outro file name
      setIntroFileUrl(introUrl); // Store intro file URL for preview
      setOutroFileUrl(outroUrl); // Store outro file URL for preview
      console.log("Selected intro/outro files:", [introFile, outroFile].filter(Boolean));
      console.log("Updated audio files:", newAudioFiles);
      console.log("Current audio files:", audioFiles);
      setOpen(false); // Close the dialog after adding
    } catch (error) {
      console.error("Error fetching intro/outro files:", error);
      alert("Failed to load intro or outro clips. Please try again.");
    }
  };

  // Toggle play/pause 
  const togglePlayPause = (clipId, clipUrl) => {
    if (!audioRefs.current[clipId]) {
      audioRefs.current[clipId] = new Audio(clipUrl);
    }
    const audio = audioRefs.current[clipId];

    if (playingClipId === clipId) {
      audio.pause();
      setPlayingClipId(null);
    } else {
      if (playingClipId) {
        const currentAudio = audioRefs.current[playingClipId];
        if (currentAudio) currentAudio.pause();
      }
      audio.play().catch((error) => console.error("Playback failed:", error));
      setPlayingClipId(clipId);
    }
  };

  // Send files to FastAPI backend 
  const sendAudioFiles = async () => {
    if (audioFiles.length === 0) {
      alert("Please select audio files first.");
      return;
    }

    console.log("Sending audio files:", audioFiles);
    setIsCombining(true);
    const formData = new FormData();
    audioFiles.forEach((file) => {
      formData.append("files", file);
    });

    try {
      const response = await axios.post(`${PODCAST_BASE_URL}merge-audio/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${podcast_bearer_token}`,
        },
        responseType: "blob",
      });
      const contentDisposition = response.headers["content-disposition"];
      let filename = "merged_output.mp3";
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        } else {
          console.warn("Failed to parse filename from Content-Disposition:", contentDisposition);
        }
      } else {
        console.warn("Content-Disposition header missing in response");
      }
      // let filename = contentDisposition.match(/filename="(.+)"/);
      console.log("Extracted filename:", filename); // Log the extracted filename directly
      setMergedAudioName(filename); // Set the state

      console.log("received response object", mergedAudioName);

      const url = window.URL.createObjectURL(new Blob([response.data], { type: "audio/mpeg" }));
      setMergedAudioUrl(url);
      // console.log("Merged audio filename:", filename);
    } catch (error) {
      console.error("Error uploading files:", error);
      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
      }
    } finally {
      setIsCombining(false);
    }
  };

  const handleTranscript = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      setTranscriptFile(files[0]);
      setTranscriptMode("file");

      const reader = new FileReader();
      reader.onload = (event) => {
        setTranscriptText(event.target.result);
      };
      reader.readAsText(files[0]);

      setMetadata(null);
      setMetadataError(null);
    }
  };


  const generateSlug = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  };

  // Meta data generation function
  const generateMetaData = async () => {
    if (!transcriptFile && !transcriptText) {
      alert("Please upload a transcript file or paste transcript text.");
      return;
    }
    setIsGenerating(true);
    setMetadataError(null);

    const formData = new FormData();
    if (transcriptMode === "file" && transcriptFile) {
      formData.append("transcript_file", transcriptFile);
    }
    if (transcriptMode === "text" && transcriptText) {
      formData.append("transcript_text", transcriptText);
    }

    try {
      const response = await axios.post(`${PODCAST_BASE_URL}generate-metadata/`, formData, {
        headers: {
          Authorization: `Bearer ${podcast_bearer_token}`,
          "Content-Type": "multipart/form-data",
          "Accept": "application/json",
        },
        responseType: "blob",
      });
      const text = await response.data.text();
      const metadataJson = JSON.parse(text);
      setMetadata(metadataJson);
      // console.log("Generated metadata:", metadataJson);
      // console.log("Title:", metadataJson?.Title);
      // console.log("Summary:", metadataJson?.Description);
      // console.log("Keywords:", metadataJson?.tags);

      // Update form field states
      setTitle(metadataJson?.Title || "");
      setDescription(metadataJson?.Description || "");
      setKeywords(metadataJson?.tags || "");
      setEngUrl(generateSlug(metadataJson?.Title || ""));
      setGenre(metadataJson?.genre || "");
    } catch (error) {
      console.error("Error generating metadata:", error);
      if (error.response) {
        const errorText = await error.response.data.text();
        setMetadataError(errorText || "Failed to generate metadata. Please try again.");
        console.error("Response data:", errorText);
        console.error("Response status:", error.response.status);
      } else {
        setMetadataError("Network error. Please check your connection and try again.");
      }
    } finally {
      setIsGenerating(false);
    }
  };


  // Refined sendPodcastData
  const sendPodcastData = async () => {
    if (!metadata) {
      alert("Please generate metadata first.");
      return null;
    }
    if (!mergedAudioName) {
      alert("Please combine clips first.");
      return null;
    }
    if (!transcriptText) {
      alert("Please upload and process the transcript file.");
      return null;
    }

    const podcastData = {
      Title: metadata?.Title || title,
      Description: metadata?.Description || description,
      tags: metadata?.tags || keywords,
      Slug: metadata?.slug || engUrl,
      genre: metadata?.genre || genre,
      Category: category,
      SubCategory: subCategory,
      Referenced_Url: referencedUrl,
      filename: mergedAudioName,
      // audioSet: JSON.stringify({
      //   intro: introFileName,
      //   llm: llmFileName,
      //   outro: outroFileName
      // }), 
      transcript: transcriptText
    };

    if (!podcastData) return; // Exit if data preparation fails

    try {
      console.log("Sending podcast data:", podcastData);
      const response = await axios.post(`${PODCAST_BASE_URL}createPodcast/`, podcastData, {
        headers: {
          Authorization: `Bearer ${podcast_bearer_token}`,
          "Content-Type": "application/json",
          "Accept": "application/json",
        }
      });
      console.log("Podcast creation response:", response.data);
      alert("Podcast published successfully!");
      // Optionally, reset states or redirect
    } catch (error) {
      console.error("Error sending podcast data:", error);
      alert("Failed to publish podcast. Please try again.");
    }
  };

  return (
    <Layout>
      {/* Tab nav inserted above main */}
      <div className="mx-auto max-w-7xl my-6 px-4 lg:px-0">
        <div className='flex justify-center mb-6'>
          <nav className="flex divide-x divide-gray-200 rounded-lg shadow overflow-hidden">

            {menu.map((item) => (
              <button
                key={item.id}
                onClick={() => setActive(item.id)}
                className={`group relative min-w-0 flex-1 overflow-hidden ${active === item.id
                  ? "bg-red-500 hover:bg-red-600 text-gray-50 hover:text-gray-50"
                  : "bg-gray-50 hover:bg-gray-100 text-gray-500 hover:text-gray-500"
                  } px-8 py-4 text-center text-sm font-bold uppercase focus:z-10`}
              >
                <span>{item.label}</span>
                <span
                  aria-hidden="true"
                  className={`${active === item.id
                    ? "bg-red-500"
                    : ""
                    } absolute inset-x-0 bottom-0 h-0.5`}
                />
              </button>
            ))}
          </nav>
        </div>
      </div>

      <main>
        {active === 1 && (
          <div className="mx-auto max-w-7xl my-6 px-4 lg:px-0">
            <div className="text-gray-50 bg-white rounded-2xl shadow-lg overflow-hidden">

              {/* HEADER */}
              <div className="px-8 py-6 grid grid-cols-1 lg:grid-cols-2 items-center border-b border-gray-200">
                <div className="min-w-0">
                  <h2 className="text-xl lg:text-lg font-bold text-gray-900 sm:text-2xl">
                    Your Podcasts
                  </h2>
                </div>
                {/* filter functionality */}
                <div>
                  <div className="flex flex-wrap gap-4 justify-end">
                    {/* CATEGORY */}
                    <div>
                      <label className="block text-xs font-semibold text-gray-700 uppercase mb-1">
                        Category
                      </label>
                      <select
                        className="border border-gray-300 rounded-md px-3 py-2 text-sm w-44 text-gray-900"
                        value={selectedCategory}
                        onChange={(e) => {
                          setSelectedCategory(e.target.value);
                          setSelectedSubCategory(""); 
                        }}
                      >
                        <option value="">All</option>
                        {Object.keys(Category_map).map((cat) => (
                          <option key={cat} value={cat}>
                            {cat}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* SUB CATEGORY */}
                    <div>
                      <label className="block text-xs font-semibold text-gray-700 uppercase mb-1">
                        Sub Category
                      </label>
                      <select
                        className="border border-gray-300 rounded-md px-3 py-2 text-sm w-44 text-gray-900"
                        value={selectedSubCategory}
                        onChange={(e) => setSelectedSubCategory(e.target.value)}
                        disabled={!selectedCategory}
                      >
                        <option value="">All</option>
                        {selectedCategory &&
                          Category_map[selectedCategory]?.map((sub) => (
                            <option key={sub} value={sub}>
                              {sub}
                            </option>
                          ))}
                      </select>
                    </div>

                    {/* CLEAR */}
                    <div className="flex items-end">
                      <button
                        className="px-4 py-2 text-sm font-semibold bg-gray-200 hover:bg-gray-300 rounded-md"
                        onClick={() => {
                          setSelectedCategory("");
                          setSelectedSubCategory("");
                        }}
                      >
                        Clear
                      </button>
                    </div>
                  </div>

                </div>
              </div>

              {/* TABLE */}
              <div className="overflow-x-auto">
                <table className="table-auto w-full">
                  <thead className="text-xs font-semibold uppercase text-gray-400 bg-slate-100">
                    <tr>
                      {/* <th className="px-3 py-5 text-center text-sm font-semibold text-gray-900">
                        ID
                      </th> */}
                      <th className="px-5 py-5 text-left text-sm font-semibold text-gray-900">
                        Title
                      </th>
                      <th className="px-3 py-5 text-left text-sm font-semibold text-gray-900">
                        Description
                      </th>
                      {/* <th className="px-3 py-5 text-left text-sm font-semibold text-gray-900">
                        Tags
                      </th> */}
                      <th className="py-5 pl-3 pr-8 text-right text-sm font-semibold text-gray-900">
                        Genre
                      </th>
                      <th className="py-5 pl-3 pr-8 text-right text-sm font-semibold text-gray-900">
                        Audio
                      </th>
                      <th className="py-5 pl-1 pr-5 text-right text-sm font-semibold text-gray-900">
                        Created At
                      </th>
                    </tr>
                  </thead>

                  <tbody className="text-sm divide-y divide-gray-100">
                    {listingLoading ? (
                      <tr>
                        <td
                          colSpan="5"
                          className="text-center py-6 text-gray-500"
                        >
                          Loading...
                        </td>
                      </tr>
                    ) : (
                      filteredListing.map((pod) => (
                        <tr
                          key={pod._id}
                          className="border-b border-gray-200 even:bg-slate-50"
                        >
                          {/* ID */}
                          {/* <td className="px-3 py-3 text-center text-sm text-gray-700">
                            {pod.Id}
                          </td> */}

                          {/* TITLE */}
                          <td className="px-6 py-3 text-left text-sm text-gray-700">
                            {pod.Title}
                          </td>

                          {/* DESCRIPTION */}
                          <td className="px-3 py-3 text-left text-sm text-gray-700 max-w-xl">
                            {pod.Description}
                          </td>

                          {/* TAGS */}
                          {/* <td className="px-3 py-3 text-left text-sm text-gray-700">
                            {pod.tags}
                          </td> */}

                          {/* Genre */}
                          <td className="py-3 pl-3 pr-8 text-right text-xs text-gray-500">
                            {pod.genre === "" ? "N/A" : pod.genre}
                          </td>
                          <td className="px-3 py-3 text-left text-sm text-gray-700 max-w-xl">
                            {playingClipId === pod.Id ? (
                              <PauseCircleIcon
                                className="w-6 h-6 text-gray-600 inline-block me-2 cursor-pointer"
                                onClick={() => togglePlayPause(pod.Id, pod.GcsAudioPath)}
                              />
                            ) : (
                              <PlayCircleIcon
                                className="w-6 h-6 text-gray-600 inline-block me-2 cursor-pointer"
                                onClick={() => togglePlayPause(pod.Id, pod.GcsAudioPath)}
                              />
                            )}
                          </td>
                          <td className="px-3 py-3 text-left text-sm text-gray-700 max-w-xl">
                            {convertDateTimeToFormat(pod?.PublishedUtc, 2)}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {/* PAGINATION SECTION */}
              <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
                <div className="flex flex-1 justify-between sm:hidden">
                  <button className="px-4 py-2 border bg-white rounded-md text-sm text-gray-700">
                    Previous
                  </button>
                  <button className="px-4 py-2 border bg-white rounded-md text-sm text-gray-700">
                    Next
                  </button>
                </div>

                <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
                  <nav className="isolate inline-flex p-4" aria-label="Pagination">
                    <button className="px-2 py-2 rounded-l-md ring-1 ring-gray-300 text-gray-400 hover:bg-slate-50" disabled={page === 0}
                      onClick={() => setPage(page - 1)}>
                      <ChevronLeftIcon className="h-5 w-5" />
                    </button>

                    {Array.from({ length: Math.min(5, totalPages) }).map((_, idx) => {
                      const pageNumber = idx;
                      return (
                        <button
                          key={pageNumber}
                          onClick={() => setPage(pageNumber)}
                          className={`px-4 py-2 text-sm font-semibold ring-1 ring-gray-300
        ${page === pageNumber ? "bg-red-600 text-white" : "text-gray-900 hover:bg-slate-50"}`}
                        >
                          {pageNumber + 1}
                        </button>
                      );
                    })}

                    <button className="px-2 py-2 rounded-r-md ring-1 ring-gray-300 text-gray-400 hover:bg-slate-50" disabled={page >= totalPages - 1}
                      onClick={() => setPage(page + 1)}>
                      <ChevronRightIcon className="h-5 w-5" />
                    </button>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        )}


        {active === 2 && (
          <div className="mx-auto max-w-7xl my-6 px-4 lg:px-0">
            <div className="bg-white rounded-2xl">
              <div className="mx-auto">
                <div className="px-8 py-6 flex flex-wrap lg:flex-nowrap items-center md:justify-between border-b border-gray-200">
                  <div className="min-w-full lg:min-w-0 flex-1 mb-4 lg:mb-0">
                    <h2 className="text-lg font-bold text-gray-900 sm:truncate sm:text-2xl sm:tracking-tight">
                      Podcast - Automation
                    </h2>
                  </div>
                  <div className="flex flex-wrap gap-4 lg:flex-nowrap w-full lg:w-auto flex-shrink-0 md:ml-4 md:mt-0 items-center">
                    <button type="button" className="px-6 py-3 text-base font-medium text-white inline-flex items-center bg-gray-700 hover:bg-gray-800 focus:ring-4 focus:outline-none focus:ring-gray-300 rounded-full text-center">
                      <BookmarkSquareIcon className="w-5 h-5 text-white me-1" />
                      Save as Draft
                    </button>
                    <button type="button" className="px-6 py-3 text-base font-medium text-white inline-flex items-center bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 rounded-full text-center" onClick={sendPodcastData}>
                      <PaperAirplaneIcon className="w-5 h-5 text-white me-1" />
                      Publish Podcast
                    </button>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-4">
                <div className="col-span-4 lg:col-span-3">
                  <div className="w-full h-full flex flex-col justify-between">
                    <div className="p-6 flex-1 flex justify-center items-center">
                      <div className="w-96">
                        <div className="flex gap-6">
                          <div className="flex items-center justify-center w-full">
                            <label htmlFor="dropzone-file" className="flex flex-col items-center justify-center w-full h-40 border border-gray-400 border-dashed rounded-lg cursor-pointer bg-gray-50">
                              <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                <ArrowUpTrayIcon className="w-6 h-6 mb-2" />
                                <p className="mb-2 text-sm text-gray-700">Upload the notebook LLM file ready for Podcast</p>
                                <p className="text-xs text-gray-500">MP4, MP3, or MKV</p>
                                {llmFileName && (
                                  <p className="mt-2 text-sm text-black-900 truncate max-w-full">Selected: {llmFileName}</p>
                                )}
                              </div>
                              <input id="dropzone-file" type="file" className="hidden" accept="audio/*" multiple={false} onChange={handleAudioFiles} />
                            </label>
                          </div>
                        </div>
                        <div className="mt-4 flex flex-col items-center">
                          <button type="button" onClick={() => setOpen(true)} className="px-3 py-2 text-xs font-medium text-center inline-flex items-center text-white bg-blue-700 rounded-full hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 uppercase">
                            <MicrophoneIcon className="w-4 h-4 text-white me-1" />
                            Add Intro & Exit Clip
                          </button>
                          {(introFileName || outroFileName) && (
                            <div className="mt-2 text-xs text-gray-600 text-center w-full">
                              {introFileName && (
                                <div className="flex items-center justify-center mb-2">
                                  <p className="mr-2">Intro: {introFileName}</p>
                                  <MediaThemeTailwindAudio style={{ width: "100%" }}>
                                    <audio
                                      slot="media"
                                      src={introFileUrl}
                                      playsInline
                                      crossOrigin="anonymous"
                                    ></audio>
                                  </MediaThemeTailwindAudio>
                                </div>
                              )}
                              {outroFileName && (
                                <div className="flex items-center justify-center">
                                  <p className="mr-2">Outro: {outroFileName}</p>
                                  <MediaThemeTailwindAudio style={{ width: "100%" }}>
                                    <audio
                                      slot="media"
                                      src={outroFileUrl}
                                      playsInline
                                      crossOrigin="anonymous"
                                    ></audio>
                                  </MediaThemeTailwindAudio>
                                </div>
                              )}
                            </div>
                          )}
                          <Dialog open={open} onClose={setOpen} className="relative z-10">
                            <DialogBackdrop
                              transition
                              className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                            />
                            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                <DialogPanel
                                  transition
                                  className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                                >
                                  <table className="relative min-w-full divide-y divide-gray-300 dark:divide-white/15">
                                    <thead className="bg-gray-50 dark:bg-gray-800/75">
                                      <tr>
                                        <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-bold text-gray-900 sm:pl-6 dark:text-gray-200">
                                          Intro Clip
                                        </th>
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-bold text-gray-900 dark:text-gray-200">
                                          Exit Clip
                                        </th>
                                        <th scope="col" className="py-1.5 pl-3 pr-4 sm:pr-6 text-right">
                                          <button type="button" onClick={() => setOpen(false)}>
                                            <XCircleIcon className="w-7 h-7 hover:text-red-600 mt-1.5" />
                                          </button>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200 bg-white dark:divide-white/10 dark:bg-gray-800/50">
                                      {introOutroClips.map((set) => (
                                        <tr key={set.id} className="even:bg-gray-50 dark:even:bg-gray-800/50">
                                          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm text-gray-900 sm:pl-6 dark:text-white">
                                            {playingClipId !== `intro-${set.id}` ? (
                                              <PlayCircleIcon
                                                className="w-6 h-6 text-gray-600 inline-block me-2 cursor-pointer"
                                                onClick={() => togglePlayPause(`intro-${set.id}`, set.intro.url)}
                                              />
                                            ) : (
                                              <PauseCircleIcon
                                                className="w-6 h-6 text-gray-600 inline-block me-2 cursor-pointer"
                                                onClick={() => togglePlayPause(`intro-${set.id}`, set.intro.url)}
                                              />
                                            )}
                                            <span className="text-gray-900">{set.intro.name}</span>
                                          </td>
                                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 dark:text-gray-400">
                                            {playingClipId !== `outro-${set.id}` ? (
                                              <PlayCircleIcon
                                                className="w-6 h-6 text-gray-600 inline-block me-2 cursor-pointer"
                                                onClick={() => togglePlayPause(`outro-${set.id}`, set.outro.url)}
                                              />
                                            ) : (
                                              <PauseCircleIcon
                                                className="w-6 h-6 text-gray-600 inline-block me-2 cursor-pointer"
                                                onClick={() => togglePlayPause(`outro-${set.id}`, set.outro.url)}
                                              />
                                            )}
                                            <span className="text-gray-900">{set.outro.name}</span>
                                          </td>
                                          <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                            <button
                                              type="button"
                                              className="px-2 py-1.5 text-xs font-medium text-center inline-flex items-center text-white bg-blue-700 rounded-md hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 uppercase"
                                              onClick={() => handleAddIntroOutro(set.intro.url, set.outro.url)}
                                            >
                                              <PlusCircleIcon className="w-4 h-4 text-white me-1" />
                                              Add
                                            </button>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </DialogPanel>
                              </div>
                            </div>
                          </Dialog>
                        </div>
                      </div>
                    </div>
                    <div className="px-3 mb-3">
                      {mergedAudioUrl && (
                        <MediaThemeTailwindAudio style={{ width: "100%" }}>
                          <audio
                            slot="media"
                            src={mergedAudioUrl}
                            playsInline
                            crossOrigin="anonymous"
                          ></audio>
                        </MediaThemeTailwindAudio>
                      )}
                    </div>
                    <div className="flex justify-end mt-4 border-t p-6">
                      <button
                        type="button"
                        onClick={sendAudioFiles}
                        className={`px-6 py-3 text-base font-medium text-white inline-flex items-center ${isCombining ? 'bg-gray-400 cursor-not-allowed' : 'bg-gray-700 hover:bg-gray-800'} focus:ring-4 focus:outline-none focus:ring-gray-300 rounded-full text-center`}
                        disabled={isCombining}
                      >
                        {isCombining ? (
                          <>
                            <div className="animate-spin me-2">
                              <Loader2 />
                            </div>
                            Combining Clips
                          </>
                        ) : (
                          <>
                            <SparklesIcon className="w-5 h-5 text-white me-1" />
                            Combine Clips
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-span-4 lg:col-span-1 bg-gray-50 border-l border-gray-200">
                  <div className="px-6 py-4 flex flex-wrap lg:flex-nowrap items-center md:justify-between border-b border-gray-200">
                    <div className="min-w-full lg:min-w-0 flex-1 mb-4 lg:mb-0">
                      <h2 className="text-lg font-bold text-gray-900">
                        Meta Info
                      </h2>
                    </div>
                    <button
                      type="button"
                      className={`px-3 py-2 text-xs font-medium text-center inline-flex items-center text-white ${isGenerating ? 'bg-gray-400 cursor-not-allowed' : 'bg-gray-700 hover:bg-gray-800'} rounded-full focus:ring-4 focus:outline-none focus:ring-gray-300 uppercase`}
                      onClick={generateMetaData}
                      disabled={isGenerating}
                    >
                      {isGenerating ? (
                        <>
                          <div className="animate-spin me-2">
                            <Loader2 />
                          </div>
                          Generating
                        </>
                      ) : (
                        <>
                          <SparklesIcon className="w-4 h-4 text-white me-1" />
                          Generate
                        </>
                      )}
                    </button>
                  </div>
                  <div className="p-6">
                    <div className="mb-4">
                      <div className="mb-4">
                        <label className="block mb-2 text-xs uppercase font-semibold text-gray-900">
                          Transcript
                        </label>

                        {/* Toggle */}
                        <div className="flex gap-2 mb-3">
                          <button
                            type="button"
                            onClick={() => setTranscriptMode("file")}
                            className={`px-3 py-1.5 text-xs rounded-full ${transcriptMode === "file"
                              ? "bg-gray-800 text-white"
                              : "bg-gray-200 text-gray-700"
                              }`}
                          >
                            Upload File
                          </button>

                          <button
                            type="button"
                            onClick={() => setTranscriptMode("text")}
                            className={`px-3 py-1.5 text-xs rounded-full ${transcriptMode === "text"
                              ? "bg-gray-800 text-white"
                              : "bg-gray-200 text-gray-700"
                              }`}
                          >
                            Paste Text
                          </button>
                        </div>

                        {/* FILE MODE */}
                        {transcriptMode === "file" && (
                          <input
                            className="block w-full text-sm text-gray-900 bg-white border border-gray-300 rounded-md cursor-pointer py-2 px-2"
                            type="file"
                            accept="text/plain"
                            onChange={handleTranscript}
                          />
                        )}

                        {/* TEXT MODE */}
                        {transcriptMode === "text" && (
                          <textarea
                            rows="6"
                            className="block w-full text-sm text-gray-900 bg-white border border-gray-300 rounded-md p-2"
                            placeholder="Paste your transcript here..."
                            value={transcriptText}
                            onChange={(e) => {
                              setTranscriptText(e.target.value);
                              setTranscriptFile(null);
                            }}
                          />
                        )}
                      </div>

                    </div>
                    {metadataError && (
                      <div className="mb-4 text-red-600 text-sm">{metadataError}</div>
                    )}
                    <div className="mb-4">
                      <label className="block mb-2 text-xs uppercase font-semibold text-gray-900" htmlFor="keyword-input">
                        Keyword
                      </label>
                      <input
                        id="keyword-input"
                        type="text"
                        className="bg-white border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2"
                        value={keywords}
                        onChange={(e) => setKeywords(e.target.value)}
                      />
                    </div>
                    <div className="mb-4">
                      <label className="block mb-2 text-xs uppercase font-semibold text-gray-900" htmlFor="description-textarea">
                        Description
                      </label>
                      <textarea
                        id="description-textarea"
                        rows="3"
                        className="block p-2 w-full text-sm text-gray-900 bg-white rounded-md border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Write your thoughts here..."
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                      ></textarea>
                    </div>
                    <div className="mb-4">
                      <label className="block mb-2 text-xs uppercase font-semibold text-gray-900" htmlFor="title-input">
                        Title
                      </label>
                      <input
                        id="title-input"
                        type="text"
                        className="bg-white border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                      />
                    </div>
                    <div className="mb-4">
                      <label className="block mb-2 text-xs uppercase font-semibold text-gray-900" htmlFor="eng-url-input">
                        ENG Url
                      </label>
                      <input
                        id="eng-url-input"
                        type="text"
                        className="bg-white border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2" value={engUrl} onChange={(e) => setEngUrl(e.target.value)}
                      />
                    </div>
                    <div className="mb-4">
                      <label className="block mb-2 text-xs uppercase font-semibold text-gray-900" htmlFor="genre-input">
                        Genre
                      </label>
                      <input
                        id="genre-input"
                        type="text"
                        className="bg-white border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2"
                        value={genre}
                        onChange={(e) => setGenre(e.target.value)}
                      />
                    </div>
                    <div className="mb-4">
                      <label className="block mb-2 text-xs uppercase font-semibold text-gray-900" htmlFor="category-input">
                        Category
                      </label>
                      <input
                        id="category-input"
                        type="text"
                        className="bg-white border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2"
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                      />
                    </div>
                    <div className="mb-4">
                      <label className="block mb-2 text-xs uppercase font-semibold text-gray-900" htmlFor="subcategory-input">
                        Sub Category
                      </label>
                      <input
                        id="subcategory-input"
                        type="text"
                        className="bg-white border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2"
                        value={subCategory}
                        onChange={(e) => setSubCategory(e.target.value)}
                      />
                    </div>
                    <div className="mb-4">
                      <label className="block mb-2 text-xs uppercase font-semibold text-gray-900" htmlFor="ref_Url-input">
                        Referenced URL
                      </label>
                      <input
                        id="ref_Url-input"
                        type="text"
                        className="bg-white border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2"
                        value={referencedUrl}
                        onChange={(e) => setReferencedUrl(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </main>
    </Layout>
  );
}
